import type { Cust_ICustomer } from '../Cust/Cust.ICustomer'
import { LS_get, LS_remove, LS_set } from './LS'

export function LS_customerGet(): Cust_ICustomer {
    return LS_get('customer')
}

export function LS_customerSet(customer: Cust_ICustomer) {
    LS_set('customer', customer)
}

export function LS_customerRemove() {
    LS_remove('customer')
}
